var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-menu",on:{"click":_vm.goto}},[_c('el-tooltip',{attrs:{"content":"点击查看帮助"}},[_c('svg-icon',{staticClass:"nav-icon",attrs:{"icon":"icon-kefu"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }